import {
  Category,
  DeviceThermostat,
  Extension,
  FormatListBulleted,
  Language,
  Storm,
  Translate,
  Workspaces,
} from "@mui/icons-material";
import Icon from "@mui/material/Icon";
import Login from "auth/login";
import Register from "auth/register";
import Accounts from "layouts/accounts";
import Applications from "layouts/apps";
import Audits from "layouts/audits";
import Branches from "layouts/branches";
import Categories from "layouts/categories";
import Countries from "layouts/countries";
import Languages from "layouts/languages";
import NcrPage from "layouts/ncr";
import Pillars from "layouts/pillars";
import Profile from "layouts/profile";
import Regions from "layouts/regions";
import Roles from "layouts/roles";
import Subscriptions from "layouts/subscriptions";
import SummaryGroups from "layouts/summary-groups";
import TaskPage from "layouts/tasks";
import Templates from "layouts/templates";
import Territories from "layouts/territories";
import Themes from "layouts/themes";
import Translations from "layouts/translations";
import UserLogs from "layouts/user-logs";
import Users from "layouts/users";
import CalendarPage from "./layouts/calendar";
import Departments from "layouts/departments";
import SheetTemplates from "layouts/logsheets/templates";
import Entities from "layouts/logsheets/entities";
import Competencies from "layouts/competencies";
import Properties from "layouts/logsheets/properties";
import EntityElements from "layouts/logsheets/entityElements";
import Sheets from "layouts/logsheets/sheets";
import EntityCategories from "layouts/logsheets/entityCategories";
import Units from "layouts/logsheets/units";
import TemplateCategories from "layouts/logsheets/templateCategories";

const routes = (label) => [
  {
    type: "collapse",
    name: label("audit-plural"),
    key: "audits",
    icon: <Icon fontSize="small">query_stats</Icon>,
    route: "/audits",
    component: <Audits />,
    includesInternalUrls: true,
  },
  {
    type: "collapse",
    name: label("calendar"),
    key: "calendar",
    icon: <Icon fontSize="small">calendar_month</Icon>,
    route: "/calendar",
    component: <CalendarPage />,
  },
  {
    type: "collapse",
    name: label("task-plural"),
    key: "tasks",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/tasks",
    component: <TaskPage />,
  },
  {
    type: "collapse",
    name: label("ncr-plural") || "NCRs",
    key: "ncr",
    icon: <Icon fontSize="small">assignment_turned_in</Icon>,
    route: "/ncr",
    component: <NcrPage />,
  },
  {
    type: "collapse",
    name: label("account-plural"),
    key: "accounts",
    icon: <Icon fontSize="small">badge</Icon>,
    route: "/accounts",
    component: <Accounts />,
    includesInternalUrls: true,
  },
  {
    type: "group",
    name: "Logsheets",
    key: "sheets",
    icon: <Icon fontSize="small">list_alt</Icon>,
    adminOnly: true,
    components: [
      {
        type: "collapse",
        name: "Sheets",
        key: "sheets",
        icon: <FormatListBulleted fontSize="small"></FormatListBulleted>,
        route: "/sheets",
        component: <Sheets />,
        includesInternalUrls: true,
        adminOnly: true,
      },
      {
        type: "collapse",
        name: "Templates",
        key: "sheet-templates",
        icon: <Extension fontSize="small"></Extension>,
        route: "/sheet-templates",
        component: <SheetTemplates />,
        adminOnly: true,
      },
      {
        type: "collapse",
        name: "Entity groups",
        key: "logsheet-entities",
        icon: <Workspaces fontSize="small"></Workspaces>,
        route: "/logsheet-entities",
        component: <Entities />,
        adminOnly: true,
      },
      {
        type: "collapse",
        name: "Entity elements",
        key: "sheet-entity-elements",
        icon: <Translate fontSize="small"></Translate>,
        route: "/sheet-entity-elements",
        component: <EntityElements />,
        adminOnly: true,
      },
      // {
      //   type: "collapse",
      //   name: "Entity categories",
      //   key: "entity-categories",
      //   icon: <Category fontSize="small"></Category>,
      //   route: "/entity-categories",
      //   component: <EntityCategories />,
      // },
      {
        type: "collapse",
        name: "Template categories",
        key: "sheet-template-categories",
        icon: <Category fontSize="small"></Category>,
        route: "/sheet-template-categories",
        component: <TemplateCategories />,
        adminOnly: true,
      },
      {
        type: "collapse",
        name: "Properties",
        key: "sheet-properties",
        icon: <Storm fontSize="small"></Storm>,
        route: "/sheet-properties",
        component: <Properties />,
        adminOnly: true,
      },
      {
        type: "collapse",
        name: "Units",
        key: "units",
        icon: <DeviceThermostat fontSize="small"></DeviceThermostat>,
        route: "/units",
        component: <Units />,
        adminOnly: true,
      },
    ],
  },
  {
    type: "collapse",
    name: label("branch-plural"),
    key: "branches",
    icon: <Icon fontSize="small">store</Icon>,
    route: "/branches",
    component: <Branches />,
    includesInternalUrls: true,
  },
  {
    type: "collapse",
    name: label("template-plural"),
    key: "templates",
    icon: <Icon fontSize="small">extension</Icon>,
    route: "/templates",
    component: <Templates />,
  },
  {
    type: "collapse",
    name: label("pillar-plural"),
    key: "pillars",
    icon: <Icon fontSize="small">account_tree</Icon>,
    route: "/pillars",
    component: <Pillars />,
  },
  {
    type: "collapse",
    name: label("competency-plural"),
    key: "sections",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/sections",
    component: <Competencies />,
  },
  {
    type: "collapse",
    name: label("summary-group-plural"),
    key: "summary-groups",
    icon: <Icon fontSize="small">workspaces</Icon>,
    route: "/summary-groups",
    component: <SummaryGroups />,
  },
  {
    type: "collapse",
    name: label("subscription-plural"),
    key: "subscriptions",
    icon: <Icon fontSize="small">subscriptions</Icon>,
    route: "/subscriptions",
    component: <Subscriptions />,
  },
  {
    type: "collapse",
    name: label("application-plural"),
    key: "apps",
    icon: <Icon fontSize="small">apps</Icon>,
    route: "/apps",
    component: <Applications />,
  },
  {
    type: "collapse",
    name: "User Logs",
    key: "userLogs",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/user-logs",
    component: <UserLogs />,
    includesInternalUrls: true,
    adminOnly: true,
  },
  {
    type: "group",
    name: label("general-config"),
    key: "generalConfig",
    icon: <Icon fontSize="small">settings</Icon>,
    components: [
      {
        type: "collapse",
        name: label("color-palette-plural"),
        key: "colorPalettes",
        icon: <Icon fontSize="small">color_lens</Icon>,
        route: "/colorPalettes",
        component: <Themes />,
      },
      {
        type: "collapse",
        name: label("category-plural"),
        key: "categories",
        icon: <Icon fontSize="small">category</Icon>,
        route: "/categories",
        component: <Categories />,
      },
      {
        type: "collapse",
        name: label("role-plural"),
        key: "roles",
        icon: <Icon fontSize="small">assignment_ind</Icon>,
        route: "/roles",
        component: <Roles />,
      },
      {
        type: "collapse",
        name: label("department-plural"),
        key: "departments",
        icon: <Icon fontSize="small">business</Icon>,
        route: "/departments",
        component: <Departments />,
      },
      {
        type: "collapse",
        name: label("language-plural"),
        key: "languages",
        icon: <Language fontSize="small"></Language>,
        route: "/languages",
        component: <Languages />,
      },
      {
        type: "collapse",
        name: label("translation-plural"),
        key: "translations",
        icon: <Translate fontSize="small"></Translate>,
        route: "/translations",
        component: <Translations />,
      },
    ],
  },

  {
    type: "group",
    name: label("location"),
    key: "location",
    icon: <Icon fontSize="small">push_pin</Icon>,
    components: [
      {
        type: "collapse",
        name: label("country-plural"),
        key: "countries",
        icon: <Icon fontSize="small">flag</Icon>,
        route: "/countries",
        component: <Countries />,
        hidden: true,
      },
      {
        type: "collapse",
        name: label("territory-plural"),
        key: "territories",
        icon: <Icon fontSize="small">terrain</Icon>,
        route: "/territories",
        component: <Territories />,
        hidden: true,
      },
      {
        type: "collapse",
        name: label("region-plural"),
        key: "regions",
        icon: <Icon fontSize="small">place</Icon>,
        route: "/regions",
        component: <Regions />,
        hidden: true,
      },
    ],
  },
  {
    type: "collapse",
    name: label("user-plural"),
    key: "users",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/users",
    component: <Users />,
  },

  {
    type: "collapse",
    name: label("profile"),
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
  },

  {
    type: "auth",
    name: "Login",
    key: "login",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/auth/login",
    component: <Login />,
  },
  {
    type: "auth",
    name: "Register",
    key: "register",
    icon: <Icon fontSize="small">register</Icon>,
    route: "/auth/register",
    component: <Register />,
  },
];

export default routes;
